import { Component, EventEmitter, Input, Output } from '@angular/core'
import { User } from '../../../../shared/models/user'

@Component({
  selector: 'app-user-widget',
  imports: [],
  templateUrl: './user-widget.component.html',
  styleUrl: './user-widget.component.scss'
})
export class UserWidgetComponent {

  @Input({ required: true })
  user: User
  @Output()
  logout = new EventEmitter<void>()

  logOut(): void {
    this.logout.emit()
  }
}

